import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Expenses from '../../../Components/pages/expenses/Expenses';
import classes from './ExpensesPage.module.scss';
import { getConstants } from '../../../actions/constFromApi';
import { getTandECountsContractor, getTandEPendingCounts } from '../../../actions/timesheet';
import { ExpensesEmptyIcon } from '../../../Components/common/Icons';
import AlternateMessageDialog from '../../../Components/common/AlternateMessageDialogComponent/AlternateMessageDialog';

export default function ExpensesPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const constants = useSelector((state) => state.constFromApi);
  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);
  const isExpenseEmpty = useSelector((state) => state?.timesheet?.isExpenseEmpty);
  const expensePlacementStatus = useSelector((state) => state?.timesheet?.validate?.timesheet.IsValidPlacementStatus);
  const isExpensePending = useSelector((state) => state?.expenses.pending);
  const [key, setKey] = useState(1);

  useEffect(() => {
    if (searchParams.has('status') && !searchParams.has('page')) {
      setKey((prev) => prev + 1);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!constants.clients || !constants.worktypes) dispatch(getConstants(true));
    if (!isExpenseEmpty) dispatch(isApprover ? getTandEPendingCounts() : getTandECountsContractor());
  }, [constants, isExpenseEmpty]);

  const handleAlternateMessageButton = () => {
    if (isApprover || !expensePlacementStatus) {
      return navigate('/dashboard');
    }

    return navigate('/dashboard/create-claim');
  };

  return (
    <section className={`${classes.pageContainer}`}>
      {!isExpenseEmpty ? (
        <Expenses key={key} />
      ) : (
        <AlternateMessageDialog
          icon={<ExpensesEmptyIcon />}
          headerLabel={t('dashboard.createclaim.emptyexpenses')}
          startTracking={
            !isApprover ? t('dashboard.createtimesheet.starttrackingnow') : t('dashboard.createclaim.emptynotification')
          }
          mainButtonLabel={!isApprover ? t('dashboard.expenses.newbuttontxt') : t('common.general.goback')}
          mainButtonEvent={() => handleAlternateMessageButton()}
          textButtonLabel={t('dashboard.createtimesheet.gotomaindashboard')}
          textButtonHandler="/dashboard"
          isApprover={isApprover}
          placementStatus={expensePlacementStatus}
        />
      )}
    </section>
  );
}
